import React from 'react';

import { useField } from 'formik';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';

const TextInput = ({label, ...props}) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field, meta] = useField(props);

    return (
        <FormControl fullWidth error={meta.touched && meta.error && meta.error.length > 0}>
            {label && <InputLabel htmlFor={props.id || props.name}>{label}</InputLabel>}
            <Input {...field} {...props} />
            {meta.touched && meta.error ? (
                <FormHelperText>{meta.error}</FormHelperText>
            ) : null}
        </FormControl>
    )
}

export default TextInput;